import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import AddBusiness from "./pages/AddBusiness";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Profile from "./pages/user/Profile";
import { getSecureItem } from "./utils/LocalStorageManager";
import ServiceDetails from "./pages/ServiceDetails";
import Register from "./pages/Register";
import Webpage from "./pages/Webpage";
import Faq from "./pages/Faq";
import GroupItems from "./pages/GroupItems";
import { ClientProvider } from "./contexts/ClientContext";  // <-- ADD THIS
import CategorizedPage from "./pages/CategorizedPage";
import { ProtectedRoute } from "./ProtectedRoute";

const App = () => {
  const isAuthenticated = !!getSecureItem("access_token");

  return (
    <ClientProvider>   {/* <-- WRAP EVERYTHING */}
      <Router>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/group-items" element={<Layout><GroupItems /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/faq" element={<Layout><Faq /></Layout>} />
          <Route path="/service-details" element={<Layout><ServiceDetails /></Layout>} />
          <Route path="/services" element={<Layout><GroupItems /></Layout>} />
          <Route path="/listing" element={<Layout><CategorizedPage /></Layout>} />

          {/* CLIENT WEBPAGE */}
          <Route path="/webpage/:biz_code" element={<Layout><Webpage /></Layout>} />

          <Route path="/add-business" element={<Layout><AddBusiness /></Layout>} />
          
          <Route
            path="/register"
            element={!isAuthenticated ? <Layout><Register /></Layout> : <Navigate to="/" />}
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout><Profile /></Layout>
              </ProtectedRoute>
            }
          />

          {/* Catch all */}
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </Router>
    </ClientProvider>
  );
};

export default App;